export const FETCH_PAGE = "FETCH_PAGE";

export const CHECKOUT_BOOKING = "CHECKOUT_BOOKING";